import { Entidad } from "../../../../data/Entidad";
import { MEscolaridad } from "../../../../data/model/MEscolaridad";
import { IGridExtraColumns } from "../entidad/GridExtraColumns";
import { MGradoGrid } from "./MGradoGrid";

export class MEscolaridadGrid extends MEscolaridad implements IGridExtraColumns {
    TagNivel: string | number;
    TagGrado: string | number;
    TagGrupo: string | number;
    TagAlumno: string | number;
    Alumnos: Map<number, Entidad.IAlumno>;

    Grados: MGradoGrid[];

    constructor(escolaridadModel: MEscolaridad) {
        super(escolaridadModel);
        this.Alumnos = new Map(this.getAlumnosEnEscolaridad().map(a => [a.IdChild, a]));
        this.TagAlumno = this.Alumnos.size;
        this.TagNivel = this.Nombre;

        this.Grados = Array.from(this.getGradosDeEscolaridad().values())
            .map(grado => new MGradoGrid(grado));

        this.TagGrado = this.Grados.length;
        this.TagGrupo = this.Grados.reduce((suma, grado) => suma + (grado.TagGrupo as number), 0);
    }

    public getAlumnosActivos(): number {
        return Array.from(this.Alumnos.values())
            .filter(d => (d.IdChildMovimiento == Entidad.CNinioMovimiento.Activo))
            .length;
    }
}